import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import CircularProgress from '@material-ui/core/CircularProgress';

import { AppTheme } from '../../styles/AppTheme';

const ERROR_MSG = 'We are experiencing a technical issue. Contact customer care team if problem persists.'

export class UiHelper {
  static loadingView() {
    return (
      <div className='loader'></div>
    )
  }
  static errorView(caller) {
    return (
      <div className='pageError'>
        {caller.state.errMsg || ERROR_MSG}
      </div>
    )
  }

  static componentLoadingView() {
    return (
      <div className={css(Styles.container)}>
        <CircularProgress size={48} className={css(Styles.progress)} />
      </div>
    )
  }

  static emptyView(msg) {
    return (
      <div className={css(Styles.emptyContainer)}>
        <p>{msg}</p>
      </div>
    )
  }

  static componentErrorView(caller) {
    return (
      <div className={css(Styles.container)}>
        <p className={css(Styles.error)}>{caller.state.errMsg || ERROR_MSG}</p>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '88vh',
  },
  emptyContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  progress: {
    color: AppTheme.primaryColor
  },
  error: {
    textAlign: 'center',
    maxWidth: 500
  }
})


// WEBPACK FOOTER //
// ./src/common/helpers/UiHelper.js